<template>
  <div class="featured-load-placeholder" v-if="loading">
    <loading-symbol />
  </div>
  <div v-else-if="featuredProviders && featuredProviders.length" class="provider-suggestion">
    <h2>{{ $t("provider.detail.suggestion") }}</h2>
    <provider-list-view :providers="featuredProviders" />
  </div>
</template>

<style scoped>
  .featured-load-placeholder {
    margin-top: 80px;
  }

  h2 {
    margin-top: 24px;
    margin-bottom: 8px;
  }
</style>

<script>
import { mapState, mapActions } from 'vuex';
import LoadingSymbol from '@/components/LoadingSymbol.vue';
import ProviderListView from './ProviderListView.vue';

export default {
  name: 'provider-featured-offers',
  computed: {
    ...mapState({
      provider: (state) => state.provider.detail.provider,
      benefits: (state) => state.provider.detail.benefits,
      // Because featured offers are shown only on detail we can use the locations
      // that were fetched for detail map (no clusters). We just have to make sure that are already
      // fetched. So I don't render this component till the locations are defined on detail.
      providerLocations: (state) => state.location.list,
      featuredProviders: (state) => state.provider.detail.featuredProviders,
      loading: (state) => state.provider.detail.featuredProviders === undefined,
    }),
  },
  methods: {
    ...mapActions({
      fetchFeaturedOffers: 'fetchProviderFeaturedOffers',
    }),
  },
  components: {
    ProviderListView,
    LoadingSymbol,
  },
  created() {
    const params = {
      category: undefined,
      sort: 'distance',
      distanceLocation: undefined,
    };
    // Add category to search params
    if (this.benefits.length !== 0) {
      const randomBenefit = this.benefits[Math.floor(Math.random() * this.benefits.length)];
      // eslint-disable-next-line max-len
      params.category = randomBenefit.primaryCategory.parentCategoryId ? randomBenefit.primaryCategory.parentCategoryId
        : randomBenefit.primaryCategory.categoryId;
    }
    // Add location to search params
    if (this.providerLocations.length !== 0) {
      // eslint-disable-next-line max-len
      const randomLocation = this.providerLocations[Math.floor(Math.random() * this.providerLocations.length)];
      params.distanceLocation = `${randomLocation.latitude},${randomLocation.longitude}`;
    } else {
      params.sort = undefined;
    }
    this.fetchFeaturedOffers(params);
  },
};
</script>
